import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, AlertTriangle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { formatApiErrorDetail } from './AuthModal';

// Handles the redirect back from Google (custom OAuth): /auth/google?code=...
const GoogleAuthCallback = () => {
  const { googleExchange } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    if (!code) {
      setError('Google sign-in was cancelled.');
      return;
    }
    googleExchange(code)
      .then(() => navigate('/dashboard', { replace: true }))
      .catch((err) => setError(formatApiErrorDetail(err.response?.data?.detail) || 'Google sign-in failed.'));
  }, [googleExchange, navigate]);

  return (
    <div className="min-h-screen bg-[#FFF2EC] flex items-center justify-center px-6" data-testid="google-auth-callback">
      {error ? (
        <div className="text-center">
          <AlertTriangle className="w-10 h-10 mx-auto text-[#A388EE] mb-3" />
          <p className="font-semibold text-[#1A1514] mb-1">{error}</p>
          <button onClick={() => navigate('/')} className="text-sm text-[#FF6B4A] underline underline-offset-2" data-testid="google-auth-back-btn">
            Back to home
          </button>
        </div>
      ) : (
        <div className="text-center">
          <Loader2 className="w-10 h-10 animate-spin mx-auto text-[#FF6B4A] mb-3" />
          <p className="font-semibold text-[#1A1514]">Signing you in…</p>
        </div>
      )}
    </div>
  );
};

export default GoogleAuthCallback;
